<template>
  <div>
    <div ref="backDiv" id="back-div" v-show="isActive" class="back-div"></div>
    <div id="drawer" class="drawer" :class="{ active: isActive }" :style="getStyle()">
      <a class="hamburger clearfix" @click.prevent="$emit('closed')">
        <i class="material-icons md-36">menu</i>
      </a>
      <ul class="nav flex-column clearfix" v-if="user">
        <li class="nav-item">
          <router-link class="nav-link active" to="/profile">My Account</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: useStampCollection?'userStamps':'loyalty', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
          >Loyalty</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: 'orderhistory', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
          >Order History</router-link>
        </li>
        <li class="nav-item">
          <router-link
            class="nav-link"
            :to="{ name: 'ordertracking', params: {storeid: currentStoreDoc.ID, storename: currentStoreDoc.Name.split(' ').join('-') } }"
          >Order Tracking</router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" @click="signOut">Log Out</a>
        </li>
      </ul>
      <ul class="nav flex-column clearfix" v-else-if="viewConfig.LogIn">
        <li class="nav-item">
          <router-link class="nav-link active" to="/login">Login</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link active" to="/register">Register</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Drawer",

  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "mobileStyles",
      "currentStoreDoc",
      "useStampCollection"
    ])
  },

  mounted() {
    var that = this;
    this.$refs.backDiv.onclick = function() {
      if (that.isActive) {
        that.$emit("closed");
      }
    };
  },
  methods: {
    ...mapActions(["logout"]),
    signOut() {
      this.logout();
      this.$router.push("/");
    },
    navigateShoppingcart() {
      this.$router.push("/store/" + this.currentstore);
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryColourImportant);
      styles.push(this.mobileStyles.nav);
      return styles;
    }
  }
};
</script>
